import React from "react";

const TextIcon: React.FC = () => (
    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="20" height="20"
         viewBox="0 0 20 20">
        <defs>
            <path id="s3qza"
                  d="M422.96 1181.993c.55 0 1 .45 1 1.001v5.01c0 .551-.45 1.002-1 1.002-.35 0-.65-.17-.82-.43-.5.27-1.07.43-1.68.43a3.507 3.507 0 0 1 0-7.013c.61 0 1.18.16 1.68.43.17-.26.47-.43.82-.43m-2.5 5.012c.82 0 1.5-.673 1.5-1.506s-.68-1.505-1.5-1.505a1.5 1.5 0 0 0-1.5 1.505 1.5 1.5 0 0 0 1.5 1.506m-4.51.67c.17.53-.11 1.09-.63 1.271-.11.03-.22.05-.32.05a.997.997 0 0 1-.95-.68l-.77-2.321h-4.56l-.77 2.32c-.18.52-.74.801-1.27.631-.52-.18-.8-.74-.63-1.27l3.12-9.355c.27-.8.99-1.321 1.83-1.321.84 0 1.56.52 1.83 1.32zm-3.34-3.681l-1.61-4.843-1.61 4.843zm10.39 9.004h-16a1 1 0 1 1 0-2.001h16a1 1 0 1 1 0 2.001m-4 4.002h-12a1 1 0 1 1 0-2.001h12a1 1 0 1 1 0 2.001"/>
            <clipPath id="s3qzb">
                <use xlinkHref="#s3qza"/>
            </clipPath>
        </defs>
        <g>
            <g transform="translate(-405 -1177)">
                <g>
                    <use fill="#1a2024" xlinkHref="#s3qza"/>
                </g>
                <g clipPath="url(#s3qzb)">
                    <g>
                        <path fill="#919eab" d="M1177 405h20v20h-20z"/>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export default TextIcon;
